import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { collection } from "firebase/firestore";

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: "siblingkinect-49d16.firebaseapp.com",
	projectId: "siblingkinect-49d16",
	storageBucket: "siblingkinect-49d16.firebasestorage.app",
	messagingSenderId: "219561313132",
	appId: "1:219561313132:web:00640663e8914a8a086949",
	measurementId: "G-1GXHNXXNJW",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Create references to our collections
export const usersCollection = collection(db, "users");
export const authorizedEmailsCollection = collection(db, "authorizedEmails");
